import { Table, TableBody, TableRow, TableHead, TableContainer, TableCell } from '@mui/material'
import EditField from 'components/DocumentDetail/Editor/EditField'
import EditRow from 'components/DocumentDetail/Editor/EditRow'
import FullHeightFlexContainer from 'components/ui/FullHeightFlexContainer'
import { DocumentBuilder } from 'entities/DocumentsOcrBuilder'
import getOcrBuilderFields from 'entities/getOcrBuilderFields'
import { useHighlightContext } from 'hooks/useHighlightContext'

interface Props {
  docDetail: DocumentBuilder
}

function Base({ docDetail }: Props) {
  const { update: updateHL } = useHighlightContext()
  const { docInfo, config, isChecking } = docDetail
  const currentFields = getOcrBuilderFields(docDetail)

  const rows = currentFields.map((field) => {
    /**
     * - only show when config[key].display is true
     * - hide if field is not verifiable item during checking
     */

    const { display, verify } = config?.[field?.label || ''] || {}
    let style
    if (display === false || (!docInfo.isVerifyRegistered && verify === false && isChecking)) {
      style = { display: 'none' }
    }

    field.compProps = {
      ...field.compProps,
      disabled: !docDetail.canEdit() || field.compProps.disabled,
    }

    return (
      <EditRow
        style={style}
        key={field.name}
        label={field.label}
        required={Boolean(field.rules?.required)}
      >
        <EditField {...field} onFocus={() => updateHL(field.label || null, false)} />
      </EditRow>
    )
  })

  return (
    <FullHeightFlexContainer>
      <TableContainer>
        <Table stickyHeader size="medium" aria-label="base fields table">
          <TableHead data-testid="table-head-base-edit">
            <TableRow>
              <TableCell>フィールド名</TableCell>
              <TableCell>編集結果</TableCell>
            </TableRow>
          </TableHead>
          <TableBody data-testid="table-body-base-edit">{rows}</TableBody>
        </Table>
      </TableContainer>
    </FullHeightFlexContainer>
  )
}

export default Base
